import { Account } from 'features/account/types'
import { DataLimits } from '../types'

const MEGABYTE = 1024 * 1024

interface TableSizeStats {
  size?: number
  nrows: number
}
export function checkAccountTableQueryLimits(table: TableSizeStats, account: Account | Record<string, never>) {
  if (!account.quotas) {
    return undefined
  }

  return checkTableQueryLimits(table, {
    maxRows: account.quotas.max_rows_per_table_layer,
    maxSize: account.quotas.max_size_per_table_layer * MEGABYTE
  })
}

export function checkTableQueryLimits(table: TableSizeStats, limits: DataLimits): DataLimits | undefined {
  const { size: tableSize, nrows: tableRows } = table
  const { maxRows, maxSize } = limits

  const sizeLimitApplies = typeof tableSize === 'number' && typeof maxSize === 'number' && maxSize > 0
  const rowsLimitApplies = !sizeLimitApplies && typeof maxRows === 'number' && maxRows > 0

  if (sizeLimitApplies && tableSize > maxSize) {
    const estimatedRowsSafeForQuery = Math.floor((maxSize * tableRows) / tableSize / 2)
    return { maxRows: estimatedRowsSafeForQuery }
  }

  if (rowsLimitApplies) {
    return tableRows > maxRows ? { maxRows: maxRows } : undefined
  }

  return undefined
}
